import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import WhatsAppConnections from './pages/WhatsAppConnections';
import SendMessage from './pages/SendMessage';
import MessageLogs from './pages/MessageLogs';
import APIKeys from './pages/APIKeys';
import Profile from './pages/Profile';
import ChangePassword from './pages/ChangePassword';
import Chatbot from './pages/Chatbot';
// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsers from './pages/admin/AdminUsers';
import AdminAnalytics from './pages/admin/AdminAnalytics';
import AdminSystem from './pages/admin/AdminSystem';
import AdminWhatsApp from './pages/admin/AdminWhatsApp';
import AdminSettings from './pages/admin/AdminSettings';
import AdminLogs from './pages/admin/AdminLogs';
import AdminSubscriptionPlans from './pages/admin/AdminSubscriptionPlans';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');
    if (token) {
      // Parse stored user to get force_password_change flag
      let userData = { token };
      if (storedUser) {
        try {
          const parsed = JSON.parse(storedUser);
          userData.force_password_change = parsed.force_password_change || false;
        } catch (e) {
          // Ignore parse errors
        }
      }
      setUser(userData);
    }
    setLoading(false);
  }, []);

  const PrivateRoute = ({ children }) => {
    if (loading) return <div>Loading...</div>;
    if (!user) return <Navigate to="/login" />;
    // Check if force_password_change is required
    if (user.force_password_change) {
      return <Navigate to="/change-password" />;
    }
    return children;
  };

  const PublicRoute = ({ children }) => {
    if (loading) return <div>Loading...</div>;
    return !user ? children : <Navigate to="/dashboard" />;
  };

  // Admin route protection
  const AdminRoute = ({ children }) => {
    const adminToken = localStorage.getItem('admin_token');
    if (!adminToken) {
      return <Navigate to="/admin/login" />;
    }
    return children;
  };

  const AdminPublicRoute = ({ children }) => {
    const adminToken = localStorage.getItem('admin_token');
    if (adminToken) {
      return <Navigate to="/admin/dashboard" />;
    }
    return children;
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<PublicRoute><LoginPage setUser={setUser} /></PublicRoute>} />
        <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard user={user} /></PrivateRoute>} />
        <Route path="/whatsapp" element={<PrivateRoute><WhatsAppConnections user={user} /></PrivateRoute>} />
        <Route path="/send-message" element={<PrivateRoute><SendMessage user={user} /></PrivateRoute>} />
        <Route path="/message-logs" element={<PrivateRoute><MessageLogs user={user} /></PrivateRoute>} />
        <Route path="/api-keys" element={<PrivateRoute><APIKeys user={user} /></PrivateRoute>} />
        <Route path="/chatbot" element={<PrivateRoute><Chatbot user={user} /></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute><Profile user={user} setUser={setUser} /></PrivateRoute>} />
        <Route path="/change-password" element={
          user ? <ChangePassword user={user} setUser={setUser} /> : <Navigate to="/login" />
        } />
        <Route path="/" element={<LandingPage />} />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminPublicRoute><AdminLogin /></AdminPublicRoute>} />
        <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
        <Route path="/admin/subscription-plans" element={<AdminRoute><AdminSubscriptionPlans /></AdminRoute>} />
        <Route path="/admin/analytics" element={<AdminRoute><AdminAnalytics /></AdminRoute>} />
        <Route path="/admin/system" element={<AdminRoute><AdminSystem /></AdminRoute>} />
        <Route path="/admin/whatsapp" element={<AdminRoute><AdminWhatsApp /></AdminRoute>} />
        <Route path="/admin/settings" element={<AdminRoute><AdminSettings /></AdminRoute>} />
        <Route path="/admin/logs" element={<AdminRoute><AdminLogs /></AdminRoute>} />
        <Route path="/admin" element={<Navigate to="/admin/dashboard" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
